import {inject, Injectable} from '@angular/core';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {I18nService} from '@shared/services/i18n.service';
import {TLanguageLabel} from '@shared/enums/language';

@Injectable({
  providedIn: 'root',
})
export class PageTitleStrategy extends TitleStrategy {
  private title = inject(Title);
  private i18n = inject(I18nService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);

    if (title) {
      this.title.setTitle(this.i18n.translate(`page_title.${title}` as TLanguageLabel));
    }
  }
}
